import {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import DataViewHeader from '../components/DataView/DataViewHeader';
import DataViewRow from '../components/DataView/DataViewRow';
import Graph from '../components/Graph';
import {DataViewValueList} from '../models/DataViewValueList';
import CollectionService from '../services/collectionServise';
import {convertDataForDataView, formatDate} from '../util';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './CSS/DataView.css';

const DataView: React.FC = () => {
    const collectionService = new CollectionService();
    const params = useParams();
    const collectionId = params.id;

    const [header, setHeader] = useState<string[]>([]);
    const [data, setData] = useState<DataViewValueList>({});

    const nowDateTime = new Date();
    const yesterDateTime = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate() - 1);

    const [startDate, setStartDate] = useState<Date>(yesterDateTime);
    const [endDate, setEndDate] = useState<Date>(nowDateTime);

    useEffect(() => {
        update();
    }, []);

    const update = () => {
        if (collectionId !== undefined) {
            const startDateTime = formatDate(startDate, 'yyyy-MM-ddTHH:mm:ssZ');
            const endDateTime = formatDate(endDate, 'yyyy-MM-ddTHH:mm:ssZ');
            const readPromise = collectionService.readData(collectionId, startDateTime, endDateTime);

            readPromise
                .then((result) => {
                    if (result.data !== undefined) {
                        const [header, valueList] = convertDataForDataView(result.data);

                        setHeader(header);
                        setData(valueList);
                    }
                })
                .catch((reson) => {
                    console.error(reson);
                });
        }
    };

    const onChangeStartDate = (date: Date) => {
        if (date !== null) {
            setStartDate(date);
            update();
        }
    };

    const onChangeEndDate = (date: Date) => {
        if (date !== null) {
            setEndDate(date);
            update();
        }
    };

    return (
        <div id='DataViewPage'>
            <div className='breadcrumb'>
                <Link to='/collections'>
                    <span className='material-symbols-outlined'>arrow_back_ios</span>
                    <span className='breadcrumb-text'>コレクション一覧</span>
                </Link>
            </div>
            <div className='content'>
                <h2>データ表示</h2>
                <div id='date-picker'>
                    <div>
                        <label>表示開始日時</label>
                        <DatePicker dateFormat='yyyy-MM-dd HH:mm' selected={startDate} onChange={onChangeStartDate} showTimeSelect />
                    </div>
                    <div>
                        <label>表示終了日時</label>
                        <DatePicker dateFormat='yyyy-MM-dd HH:mm' selected={endDate} onChange={onChangeEndDate} showTimeSelect />
                    </div>
                </div>
                <div id='data-table'>
                    <table>
                        <thead>
                            <DataViewHeader header={header}></DataViewHeader>
                        </thead>
                        <tbody>
                            {Object.keys(data)
                                .reverse()
                                .map((key, index) => {
                                    const rowData = data[key];
                                    const createdAt = new Date(key);
                                    return <DataViewRow header={header} createdAt={createdAt} data={rowData} key={index}></DataViewRow>;
                                })}
                        </tbody>
                    </table>
                </div>
                <Graph header={header} graphData={data}></Graph>
            </div>
        </div>
    );
};

export default DataView;
